export const PRIORITY_1_NOTIFICATION_TYPES = Object.freeze([
  "conflict_opened",
  "conflict_resolved",
  "single_challenge_invite",
  "opponent_found",
  "tournament_starting",
  "tournament_one_hour_reminder",
  "result_reported",
  "upload_deadline_warning",
  "challenge_expiring",
  "attendance_confirmed",
  "presence_confirmation_required",
  "presence_confirmed",
  "admin_message",
  "tournament_cancelled_refund",
  "reward_tournament_win",
  "single_challenge_accepted",
  "single_challenge_declined",
  "creator_tournament_request_edited",
  "creator_tournament_request_approved",
  "creator_tournament_request_rejected",
  "creator_tournament_request_changes_requested",
  "group_stage_qualified",
  "group_stage_eliminated",
  "group_stage_ruling_required",
  "tournament_check_in_open",
  "tournament_check_in_reminder",
  "tournament_match_ready",
  "prize_payout_completed",
  "prize_physical_shipped",
  "prize_fulfillment_needs_action",
]);

export function isPriority1NotificationType(type) {
  return PRIORITY_1_NOTIFICATION_TYPES.includes(String(type || ""));
}

export function shouldShowPriority1Notification(notification) {
  if (!notification) return false;
  if (notification.isPriority1 === true) return true;
  if (notification.isPriority1 === false) return false;
  return isPriority1NotificationType(notification.type);
}
